<script>
import baseList from "@/views/components/base/baseConsumableCus.vue";
import CheckList from "./checkList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import config from "@/../config";
import Claim from "./claim.vue";

export default {
  extends: baseList,
  components: {
    Claim,
  },
  data() {
    return {
      table: {
        mname: "consumables_cus",
        key: "id",
        url: {
          list: "/customer/customer/inventory/list",
        },
        output: false,
      },
      tabList: [],
      actions: [
        {
          label: "批量领用",
          onClick: this.toCheckList,
          auth: "",
          type: "info",
        },
      ],
      menus: [],
      filters: [
        {
          label: "采购人",
          KeyEnter: this.search,
          name: "purchase",
          value: "",
          type: "input",
        },
        {
          label: "耗材名称",
          KeyEnter: this.search,
          name: "name",
          value: "",
          type: "input",
        },
        {
          label: "型号",
          KeyEnter: this.search,
          name: "model",
          value: "",
          type: "input",
        },
        {
          label: "适用设备",
          KeyEnter: this.search,
          name: "remark",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          type: "selection",
          width: 60,
        },
        {
          title: "货物信息",
          width: 450,
          align: "center",
          render: (h, p) => {
            return h("div", [
              h("img", {
                style: {
                  width: "60px",
                  height: "60px",
                  float: "left",
                  margin: "10px",
                  display: "block",
                },
                attrs: { src: p.row.consumableImgUrl },
              }),
              h("div", [
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      float: "left",
                      marginTop: "5px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                    domProps: {
                      title: p.row.brand,
                    },
                  },
                  p.row.brand
                ),
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      marginTop: "5px",
                      marginLeft: "5px",
                      float: "left",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                    domProps: {
                      title: p.row.name,
                    },
                  },
                  p.row.name
                ),
              ]),
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    marginTop: "5px",
                    width: "80%",
                    textAlign: "left",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                  domProps: {
                    title: "型号:" + p.row.model,
                  },
                },
                "型  号: " + p.row.model
              ),
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "80%",
                    textAlign: "left",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                  domProps: {
                    title: "适用于: " + p.row.remark,
                  },
                },
                "适用于: " + p.row.remark
              ),
            ]);
          },
        },
        {
          title: "库存数量",
          key: "num",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.num;
            return h(
              "div",
              {
                style: {
                  color: row.num <= 10 ? "red" : "",
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        {
          title: "单位",
          key: "unit",
          width: 80,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unit;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "中标单价（元）",
          minWidth: 140,
          align: "center",
          key: "unitPrice",
          render: (h, params) => {
            const row = params.row;
            const text = Number(row.unitPrice).toFixed(2);
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "市场价（元）",
          minWidth: 130,
          align: "center",
          key: "jdPrice",
        },
        {
          title: "操作",
          align: "center",
          width: 120,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              return (
                <Button
                  size="small"
                  onClick={() => this.toClaim(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  申请领用
                </Button>
              );
            },
          ],
        },
      ],
    };
  },
  created() {
    this.loadLevelData();
  },
  methods: {
    //选中
    handleSelect(selected) {
      let ids_arr = [];

      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        let consumableIn = {};
        consumableIn.inventoryId = element.id;
        consumableIn.consumableNum = element.consumableNum;
        consumableIn.consumableImgUrl = element.consumableImgUrl;
        consumableIn.brand = element.brand;
        consumableIn.name = element.name;
        consumableIn.model = element.model;
        consumableIn.remark = element.remark;
        consumableIn.num = element.num;
        consumableIn.unit = element.unit;
        consumableIn.receiveNum = 1;

        ids_arr.push(consumableIn);
      }
      this.selectedConsumable = ids_arr;
    },
    toCheckList() {
      if (!this.selectedConsumable.length > 0) {
        return $utils.toast.error("请选择耗材!");
      }
      this.$Modal.success({
        closable: true,
        title: "批量领用",
        width: "1000px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <CheckList
              style={{ margin: "0", color: "#19be6b" }}
              consumableInventory={this.selectedConsumable}
            ></CheckList>
          );
        },
      });
    },
    everyType(e) {
      this.selectedConsumable = [];
      this.query.typeId = e;
      this.$refs.tablelist.init();
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/customer/customer/consumableType/selectList", q).then((res) => {
        if (res && res.rows) {
          this.tabList = res.rows.slice(0, 8);
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.model;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "typeId") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },

    toCheck(row) {
      this.$Modal.success({
        closable: true,
        title: "领用记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Check style={{ margin: "0", color: "#19be6b" }} inventoryId={row.id}></Check>
          );
        },
      });
    },
    toClaim(row) {
      let consumableIn = {};
      consumableIn.inventoryId = row.id;
      consumableIn.consumableNum = row.consumableNum;
      consumableIn.consumableImgUrl = row.consumableImgUrl;
      consumableIn.brand = row.brand;
      consumableIn.name = row.name;
      consumableIn.model = row.model;
      consumableIn.remark = row.remark;
      consumableIn.num = row.num;
      consumableIn.unit = row.unit;
      consumableIn.receiveNum = 1;
      let consumableInventory = [];
      consumableInventory.push(consumableIn);
      this.$Modal.success({
        closable: true,
        title: "领用",
        okText: "取消",
        width: "1000px",
        showOk: false,
        render: (h) => {
          return (
            <CheckList
              style={{ margin: "0", color: "#19be6b" }}
              consumableInventory={consumableInventory}
            ></CheckList>
          );
        },
      });
    },
  },
};
</script>
<style scoped></style>
